export * from './baSlimScroll.directive';



// WEBPACK FOOTER //
// ./src/app/theme/directives/baSlimScroll/index.ts